import { ReactNode } from 'react'

type ErrorTextProps = {
  hasFilters: boolean
  providerName?: string
}

const getTitle = ({ hasFilters, providerName }: ErrorTextProps): ReactNode => {
  if (providerName) {
    /*
     * O termo buscado usa `sys-color-content-active`, o mesmo token que o
     * `mode='active'` do `WTitle` aplica. A prop nao serve aqui porque colore
     * o titulo inteiro, e o destaque e de um trecho.
     *
     * `mark` e o elemento de trecho destacado em uma busca. O fundo vem do token
     * transparente do design system, para remover o realce amarelo padrao do
     * navegador — o preset de tokens substitui `theme.colors`, entao a classe
     * `bg-transparent` do Tailwind nao existe neste projeto.
     */
    return (
      <>
        Ops, não encontramos nenhum resultado para{' '}
        <mark className='bg-gl-color-transparent-white-00 text-sys-color-content-active'>
          ‘{providerName}’
        </mark>
      </>
    )
  }

  return hasFilters
    ? 'Não encontramos parceiros com essa combinação de filtros'
    : 'Ainda não temos parceiros nessa região'
}

const getDescription = ({ hasFilters, providerName }: ErrorTextProps) => {
  if (providerName) {
    return 'Veja se digitou corretamente ou tente um nome diferente.'
  }

  return hasFilters
    ? 'Tente alterar os filtros para encontrar o parceiro que você está procurando.'
    : 'Você pode ampliar a área de busca ou procurar por uma cidade próxima.'
}

export { getTitle, getDescription }
